import { createContext } from 'react';
import type { Plan, Settings } from '@/types';

export interface SettingsContextValue {
  settings: Settings;
  plan: Plan;
  isPro: boolean;
  update: (patch: Partial<Settings>) => Promise<void>;
}

export const SettingsContext = createContext<SettingsContextValue | null>(null);
